exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VehicleBubble{\r\n\r\n}\r\n\r\n.VehicleBubble .Body > div label {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\tpadding: 5px 10px;\r\n\tfont-size: 16px;\r\n\tfont-weight: bold;\r\n\tcursor: pointer;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n}\r\n\r\n.VehicleBubble .Body {\r\n\tmax-width: 180px;\r\n\ttransition: background-color 1s ease;\r\n}\r\n\r\n.VehicleBubble .TriangleContainer > div:nth-child(2) {\r\n\ttransition: border-color 1s ease;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/view/Map/VehicleBubble/VehicleBubble.css
// module id = 717
// module chunks = 0